import React from "react";
import { makeStyles, Button } from "@material-ui/core";
// import { useHistory } from "react-router-dom";


let useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        height: '100vh',
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#050A2A',
        padding: 20,
        overflow: 'auto',
        flexDirection: 'row',
        // '@media (orientation: landscape)': {
        //     alignItems: 'flex-start',
        // },
        // '@media (orientation: portrait)': {
        //     alignItems: 'center',
        // },
      
        '@media (max-width:750px)': {
            alignItems: 'flex-start !important',
            '@media (orientation: landscape)': {
                alignItems: 'flex-start',
            },
            }
      
    },
    grid: {
        width: 700,
        height: 'auto',
        textAlign: 'center',
        maxWidth: '100%',
        '@media (max-width:750px)': {
            width: '100%',
        },
    },
    gridDesc: {
        marginTop: 15,
        marginBottom: 20,
    },
    desc: {
        margin: 0,
        padding: 0,
        fontSize: 16,
        fontWeight: 500,
        color: '#FFFFFF'
    },
    gridBtns: {
        marginTop: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
    },
    btns: {
        width: 327,
        height: 55,
        backgroundColor: '#FFFFFF',
        color: 'black',
        borderRadius: 10,
        marginTop: 10,
        fontWeight: 500,
        '&:hover': {
            backgroundColor: 'rgba(255,255,255,0.9)',
        },
        '@media (max-width:400px)': {
            width: 300,
        },
        '@media (max-width:380px)': {
            width: 270,
        }
    },
    gridSocial: {
        width: 100,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        margin: 'auto',
        marginTop: 35,
        '& img': {
            cursor: 'pointer'
        },

        '& img:hover': {
            fill: 'rgba(255,255,255,0.5) !impotrant',
        }
    }
}))

export default function Index() {

    let classes = useStyles();
    // const history = useHistory();

    const handelRout = (path) => {
        // history.push(path);
        window.open(path, "_blank");
    }

    return (
        <div className={classes['root']}>
            <div className={classes['grid']}>
                <div>
                    <img src="/assets/images/logoLinks.png" alt="" />
                </div>
                <div className={classes['gridDesc']}>
                    <p className={classes['desc']}>
                        کارگزار رسمی بورس اوراق بهادار، فرابورس،
                    </p>
                    <p className={classes['desc']}>
                        کالا و انرژی
                    </p>
                </div>
                <div className={classes['gridBtns']}>
                    <a href="https://reg.pouyanbroker.ir/" target={'_blank'}>
                        <Button type="text" className={classes['btns']}  >
                            افتتاح حساب اوراق بهادار
                        </Button>
                    </a>
                    <a href="https://pouyan.ebgo.ir/StockCode" target={'_blank'}>
                        <Button type="text" className={classes['btns']} >
                            ثبت نام در بورس کالا EBGO
                        </Button>
                    </a>
                    <Button type="text" className={classes['btns']} onClick={() => handelRout('/Shoab')}>
                        شعب کارگزاری پویان
                    </Button>
                    <Button type="text" className={classes['btns']} onClick={() => handelRout('AboutUs')} >
                        درباره پویان
                    </Button>
                    <Button type="text" className={classes['btns']} onClick={() => handelRout('/')} >
                        وب سایت کارگزاری پویان
                    </Button>
                    <a href="https://mag.pouyanbroker.com/" target={'_blank'}>
                        <Button type="text" className={classes['btns']} >
                            پویان مگ
                        </Button>
                    </a>
                    <a href="https://t.me/pouyan_brokerr" target={'_blank'}>
                        <Button type="text" className={classes['btns']} >
                            کانال‌های تلگرام کارگزاری پویان
                        </Button>
                    </a>
                </div>
                <div className={classes['gridSocial']}>
                    <a href="https://t.me/pouyanbroker_official" target={'_blank'}>
                        <img src="/assets/icons/linkes/telegram.svg" alt="" />
                    </a>
                    <a href="https://www.linkedin.com/company/pouyanbroker" target={'_blank'}>
                        <img src="/assets/icons/linkes/link.svg" alt="" />
                    </a>
                    <a href="https://www.instagram.com/pouyanbrokerage" target={'_blank'}>
                        <img src="/assets/icons/linkes/instal.svg" alt="" />
                    </a>
                </div>
            </div>
        </div>)
}
